export const mobile = "@media(max-width: 640px)";
export const desktop = "@media(min-width: 641px)";
